import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f84f1a08&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84f1a08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f84f1a08')) {
      api.createRecord('f84f1a08', component.options)
    } else {
      api.reload('f84f1a08', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f84f1a08&scoped=true", function () {
      api.rerender('f84f1a08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/workload/index.vue"
export default component.exports